/*
 * The main JavaScript file.
 */


/**
 * Frameworks and plugins.
 */
import 'plugins/plugins.js';
import 'babel-polyfill';
import { jqueryeasing } from 'jquery.easing/jquery.easing.1.3.min.js';
import { isotope } from 'isotope-layout/dist/isotope.pkgd.min.js';
import { flexslider } from 'flexslider/jquery.flexslider-min.js';


/**
 * Generic functionality.
 */
import { BrowserDetection } from 'browserdetection/browserdetection.js';


/**
 * Module functionality.
 */
import { Header, Search } from 'modules/header/header.js';
import { Hero } from 'modules/hero/hero.js';
import { GoogleMaps } from 'modules/google-maps/google-maps.js';
import { SubHero } from 'modules/sub-hero/sub-hero.js';
import { Media } from 'modules/media/media.js';


/**
 * Plugin functionality.
 */
import { Team } from 'plugins/modules/team/team.js';


/**
 * Theme functionality.
 */
import { Theme } from 'plugins/theme.js';





/**
 * Runtime.
 */

// Set a global variable to handle our app data
if ( typeof window.app === 'undefined' )
{
	window.app = {};
}

// Instantiate a new browser detection object available globally
window.app.BrowserDetection = new BrowserDetection();

// Run browser detection
window.app.BrowserDetection.detect();


// Instantiate a new header object available globally
window.app.Header = new Header();

// Add event listeners
window.app.Header.addListeners();

Hero.addListeners();
GoogleMaps.addListeners();
Search.addListeners();
SubHero.addListeners();
Media.addListeners();
Team.addListeners();
Theme.addListeners();



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/main.js